import React, { useState, useEffect, useRef } from "react"; // ADDED: useRef import

import correctAudio from "../../assets/sounds/correct_answer.mp3";
import incorrectAudio from "../../assets/sounds/wrong_answer.mp3";

const MultipleSelectImg = ({ questionData, onOptionClick, correctAnswer, video }) => {
  const { imageList, questionimagelist, questionaudio } = questionData;
  const [selectedIndexes, setSelectedIndexes] = useState([]); // Track the selected indexes

  // REMOVED: Direct new Audio() instances here. They will be managed by refs.
  // const correctSound = new Audio(correctAudio);
  // const incorrectSound = new Audio(incorrectAudio);

  // NEW CODE START: Refs for audio instances
  const questionAudioInstanceRef = useRef(null);
  const feedbackAudioInstanceRef = useRef(null); // Used for both correct and incorrect sounds
  // NEW CODE END

  // MODIFIED EFFECT HOOK: To manage the question audio instance
  useEffect(() => {
    // Cleanup previous question audio instance if it exists
    if (questionAudioInstanceRef.current) {
      questionAudioInstanceRef.current.pause();
      questionAudioInstanceRef.current.currentTime = 0;
      questionAudioInstanceRef.current = null; // Clear the ref
    }

    if (questionaudio) {
      const audio = new Audio(questionaudio);
      audio.loop = false;
      audio.volume = 0.5;
      questionAudioInstanceRef.current = audio; // Store the new audio instance in the ref

      audio
        .play()
        .then(() => {
          console.log("Question audio started playing"); // Changed "Background audio" to "Question audio" for clarity
        })
        .catch((error) => {
          console.error("Error playing question audio:", error); // Changed "background audio" to "question audio" for clarity
        });
    }
    return () => {
      if (questionAudioInstanceRef.current) {
        questionAudioInstanceRef.current.pause();
        questionAudioInstanceRef.current.currentTime = 0;
      }
    };
  }, [questionaudio]);

  const handleOptionClick = (index) => {
    let updatedIndexes;
    if (selectedIndexes.includes(index)) {
      updatedIndexes = selectedIndexes.filter((i) => i !== index);
    } else {
      updatedIndexes = [...selectedIndexes, index];
    }

    setSelectedIndexes(updatedIndexes);
    onOptionClick(updatedIndexes);

    // NEW CODE START: Stop any currently playing feedback audio before starting a new one
    if (feedbackAudioInstanceRef.current) {
      feedbackAudioInstanceRef.current.pause();
      feedbackAudioInstanceRef.current.currentTime = 0;
    }
    // NEW CODE END

    if (
      JSON.stringify(updatedIndexes.sort()) ===
      JSON.stringify(correctAnswer.sort())
    ) {
      // MODIFIED: Use ref for feedback audio
      feedbackAudioInstanceRef.current = new Audio(correctAudio);
      feedbackAudioInstanceRef.current.play();
    } else {
      // MODIFIED: Use ref for feedback audio
      feedbackAudioInstanceRef.current = new Audio(incorrectAudio);
      feedbackAudioInstanceRef.current.play();
    }
  };

  return (
    <div className="mcq-component flex w-[70%] mt-[20px] h-[87%] flex-col items-center justify-center font-mali">
      <div className="flex flex-row w-[60%] gap-[20px]">
        {questionimagelist.map((question, index) => (
          <div key={index}>
            <img src={question} alt={`Question ${index}`} />
          </div>
        ))}
      </div>
      <div className="imagelist gap-[20px] flex">
        {imageList.map((imgSrc, index) => (
          <div
            key={index}
            className="relative w-[80px] h-[80px] flex items-center justify-center cursor-pointer"
            onClick={() => handleOptionClick(index)}
          >
            {selectedIndexes.includes(index) && (
              <div className="absolute inset-0 bg-blue-500 opacity-50 rounded-full"></div>
            )}

            <img
              src={imgSrc}
              alt={`Option ${index}`}
              className={`option-item w-full h-full object-cover rounded-full transition-opacity duration-200 ease-in-out ${
                selectedIndexes.includes(index) ? "opacity-50" : "opacity-100"
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultipleSelectImg;